<div class="prime-card">
    <img class="prime-card-glow-bottom" src="assets/svg/icons/glow.svg" />
    <form [formGroup]="surveyForm" (ngSubmit)="onSubmit()">
        <div class="prime-card-wrapper">
            <header class="prime-card-header">
                <h3 class="header-title-gradient">{{ pageTitle }}</h3>
            </header>
            <section class="prime-card-body">
                <div class="body-content">
                    <ng-container *ngIf="showShimmer">
                        <web-loan-survey-shimmer></web-loan-survey-shimmer>
                    </ng-container>
                    <div class="form-field-group" *ngIf="!showShimmer">
                        <ng-container *ngFor="let question of questions; index as i">
                            <ng-container *ngIf="question.questionType === questionType.MULTIPLE.value">
                                <div class="form-field-group--with-label">
                                    <p class="form-field-group-label">{{ question.questionName }}</p>
                                    <p *ngIf="question.questionText" class="fs-md text-primary-50">
                                        {{ question.questionText }}
                                    </p>
                                    <div class="form-field-group--sub-group">
                                        <div
                                            class="selection-list selection-list--column"
                                            *ngIf="getMultiSelectFormArray(question.id)"
                                        >
                                            <ng-container *ngFor="let option of question.options; let j = index">
                                                <div
                                                    class="selection-list-item"
                                                    (click)="toggleCheckboxValue(question.id, j)"
                                                >
                                                    <span class="selection-list-item-name">{{
                                                        option.optionName
                                                    }}</span>

                                                    <mat-checkbox
                                                        [formControl]="getMultiSelectFormControl(question.id, j)"
                                                        (click)="$event.stopPropagation()"
                                                    >
                                                    </mat-checkbox>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="question.questionType === questionType.RADIO.value">
                                <div class="form-field-item">
                                    <mat-label class="label">{{ question.questionName }}</mat-label>
                                    <mat-radio-group [formControlName]="question.id.toString()">
                                        <mat-radio-button
                                            *ngFor="let option of question.options"
                                            [value]="option.optionName"
                                        >
                                            {{ option.optionName }}
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="question.questionType === questionType.SELECT.value">
                                <div class="form-field-item">
                                    <mat-label class="label">{{ question.questionName }}</mat-label>
                                    <mat-form-field class="form-field-select">
                                        <mat-select
                                            [formControlName]="question.id.toString()"
                                            [placeholder]="question?.placeHolder"
                                        >
                                            <mat-option
                                                *ngFor="let option of question.options"
                                                [value]="option.optionName"
                                            >
                                                {{ option.optionName }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="question.questionType === questionType.TEXT.value">
                                <div class="form-field-item">
                                    <mat-label class="label">
                                        {{ question.questionName }}
                                        <span
                                            *ngIf="question.isSurveyQuestion === questionRequiredStatus.OPTIONAL.value"
                                            class="optional-text"
                                            >(Optional)</span
                                        >
                                    </mat-label>

                                    <mat-form-field class="form-field-textarea">
                                        <textarea
                                            matInput
                                            [formControlName]="question.id.toString()"
                                            [placeholder]="question?.placeHolder"
                                        ></textarea>
                                    </mat-form-field>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="question.questionType === questionType.SELECT_MULTIPLE.value">
                                <div class="form-field-item">
                                    <mat-label class="label">{{ question.questionName }}</mat-label>

                                    <mat-form-field class="form-field-multiple-select">
                                        <mat-select
                                            #multipleSelect
                                            multiple
                                            [formControlName]="question.id.toString()"
                                            [placeholder]="question?.placeHolder"
                                            (selectionChange)="updateOverlayPosition(multipleSelect)"
                                        >
                                            <mat-option
                                                *ngFor="let option of question.options"
                                                [value]="option.optionName"
                                            >
                                                {{ option.optionName }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </section>
            <div class="prime-card-footer">
                <div class="prime-card-footer-right">
                    <button
                        type="button"
                        [disabled]="isVerified"
                        class="primary-outline-btn"
                        *ngIf="isCancel"
                        (click)="goBack()"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        class="primary-fill-btn"
                        [disabled]="!surveyForm.valid || isVerified || isLoading"
                    >
                        <ng-container *ngIf="!isSubmit">
                            <span *ngIf="isVerified || isLoading">Continue...<web-spinner></web-spinner> </span>
                            <span *ngIf="!isVerified && !isLoading">Continue</span>
                        </ng-container>
                        <ng-container *ngIf="isSubmit">
                            <span *ngIf="isVerified || isLoading">Submitting...<web-spinner></web-spinner> </span>
                            <span *ngIf="!isVerified && !isLoading">Submit</span>
                        </ng-container>
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>
